module.exports = __webpack_public_path__ + "img/gift6.2f009739.png";